import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "square"
}
const _hoisted_2 = ["type"]
const _hoisted_3 = ["min", "step"]
const _hoisted_4 = ["type"]
const _hoisted_5 = ["step", "type"]
const _hoisted_6 = ["type"]
const _hoisted_7 = ["step", "min", "max", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Flex = _resolveComponent("Flex")!

  return (_openBlock(), _createBlock(_component_Flex, {
    "align-items": 'center',
    "flex-direction": _ctx.labelDirection(),
    style: _normalizeStyle(_ctx.styles.container)
  }, {
    default: _withCtx(() => [
      (_ctx.labelSquare)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            class: _normalizeClass(_ctx.getLabelClass()),
            style: _normalizeStyle(_ctx.styles.label)
          }, _toDisplayString(_ctx.label), 7))
        : _createCommentVNode("", true),
      (_ctx.dataType === 'object')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.type === 'text')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form[_ctx.attr]) = $event)),
                  style: _normalizeStyle(_ctx.styles.input),
                  class: "input",
                  type: _ctx.type
                }, null, 12, _hoisted_2)), [
                  [_vModelDynamic, _ctx.form[_ctx.attr]]
                ])
              : _createCommentVNode("", true),
            (_ctx.type === 'number')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayNumber) = $event)),
                  style: _normalizeStyle(_ctx.styles.input),
                  class: "input",
                  min: String(_ctx.min),
                  step: _ctx.step,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeInput('form'))),
                  onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
                }, null, 44, _hoisted_3)), [
                  [_vModelText, _ctx.displayNumber]
                ])
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.dataType === 'read-only-value')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.type === 'text')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value) = $event)),
                    style: _normalizeStyle(_ctx.styles.input),
                    class: "input",
                    type: _ctx.type,
                    readonly: ""
                  }, null, 12, _hoisted_4)), [
                    [_vModelDynamic, _ctx.value]
                  ])
                : _createCommentVNode("", true),
              (_ctx.type === 'number')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value) = $event)),
                    step: _ctx.step,
                    style: _normalizeStyle(_ctx.styles.input),
                    class: "input",
                    type: _ctx.type,
                    readonly: ""
                  }, null, 12, _hoisted_5)), [
                    [
                      _vModelDynamic,
                      _ctx.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (_ctx.type === 'text')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value) = $event)),
                    style: _normalizeStyle(_ctx.styles.input),
                    class: "input",
                    type: _ctx.type,
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleChangeInput && _ctx.handleChangeInput(...args)))
                  }, null, 44, _hoisted_6)), [
                    [_vModelDynamic, _ctx.value]
                  ])
                : _createCommentVNode("", true),
              (_ctx.type === 'number')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value) = $event)),
                    step: _ctx.step,
                    min: String(_ctx.min),
                    max: String(_ctx.max),
                    style: _normalizeStyle(_ctx.styles.input),
                    class: "input",
                    type: _ctx.type,
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleChangeInput && _ctx.handleChangeInput(...args)))
                  }, null, 44, _hoisted_7)), [
                    [
                      _vModelDynamic,
                      _ctx.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ], 64)),
      (_ctx.innerInput)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            style: _normalizeStyle(_ctx.styles.innerInput),
            class: "inner-input-element"
          }, _toDisplayString(_ctx.innerInput), 5))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 8, ["flex-direction", "style"]))
}